import react, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { RootState, useAppSelector } from '../../../store'
import { TestUser } from '../../../models/TestUser'
import { Test } from '../../../models/Test'
import { axiosPost } from '../../Common/Axios'
import TestBox from '../../Common/TestBox'
import { ApiResult } from '../../../models/Enums'

function TestList() {
  const [testUsers, setTestUsers] = useState<TestUser[]>([])
  const [tests, setTests] = useState<Test[]>([])

  const me = useAppSelector((state: RootState) => state.user.me)

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-extra-semi
    ;(async () => {
      const payload = { id: me.id }

      try {
        const result = await axiosPost('/api/test/get_test_users', payload)

        if (result.apiResult !== ApiResult.SUCCESS) {
          console.log('get_test_users error', result.message)
          return
        }

        const tests = result.data['tests']
        const testUsers = result.data['testUsers']

        tests.forEach((test: Test) => {
          test.isComplete =
            testUsers.find(
              (testUser: TestUser) =>
                testUser.testId === test.id && testUser.userId === me.id
            )?.isComplete || false
        })

        setTests(tests)
        setTestUsers(testUsers)
      } catch (error) {
        console.log('get_test_users error', error)
      }
    })()
  }, [me.id])

  return (
    <Container>
      <Header>
        <div>직업 성격 테스트</div>
      </Header>
      <Content>
        {tests &&
          tests.map((test, index) => (
            <Link to={`/mentee/test/${test.id}`} key={index}>
              <TestBox test={test}></TestBox>
            </Link>
          ))}
      </Content>
    </Container>
  )
}

const Container = styled.div`
  grid-area: main;
  margin-bottom: 1rem;
`

const Header = styled.div`
  position: relative;
  padding: 2rem;

  & > div {
    font-size: 1.4rem;
    font-weight: 700;
    text-align: center;
  }
`

const Content = styled.div`
  min-height: 500px;
  margin-top: 20px;
`

export default TestList
